import BaseService from "./BaseService";

class UserPreferencesService {
    static endpoint = "user-preferences";
    static async GetUserPreferences(userId, token) {
        try {
            return await BaseService.get(this.endpoint, token, { id: userId });
        } catch (error) {
            console.error("There was an error fetching the user preferences!", error);
            throw error;
        }
    }

    static async CreateUserPreferences(preferences, token) {
        try {
            return await BaseService.post(this.endpoint, preferences, token);
        } catch (error) {
            console.error("There was an error creating the user preferences!", error);
            throw error;
        }
    }

    static async UpdateUserPreferences(id, preferences, token) {
        try {
            return await BaseService.put(this.endpoint, id, preferences, token);
        } catch (error) {
            console.error("There was an error updating the user preferences!", error);
            throw error;
        }
    }

    static async DeleteUserPreferences(id, token) {
        try {
            return await BaseService.delete(this.endpoint, id, token);
        } catch (error) {
            console.error("There was an error deleting the user preferences!", error);
            throw error;
        }
    }
}

export default UserPreferencesService;
